





import { Component, Vue, Provide } from "vue-property-decorator";
import { ColumnsConfig } from "@/common/BaseConfig";
import { IColumn } from "@/api/types.d";
import request from "@/api/index";
@Component
export default class AdministrativeApproval extends Vue {
  url: string = "";
  mounted() {
    this.getColumns();
    this.transfer();
  }

  /**
   * 中转函数，因App无法调用iframe内js，故使用此函数中转回调
   */
  transfer() {
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    (window as any).getToken = (parms: Object) => {
      iframe.contentWindow!.postMessage(
        {
          funcName: "getToken",
          parms: parms
        },
        "*"
      );
    };
  }

  getColumns() {
    request.getColumns(ColumnsConfig.办事服务).then(result => {
      if (result.code === 0 && result.data.dataList) {
        if (process.env.NODE_ENV === "development") {
          this.url = "http://192.168.6.136:8085/user/gov/approve.html?appId=10";
        } else {
          this.url = result.data.dataList.find(
            item => item.code == ColumnsConfig.行政审批
          )!.columnsUrl;
        }
      }
    });
  }
}
